import { Download } from '@mui/icons-material';
import { Alert, Box, Button, List, ListItem, Snackbar, TextField, Typography } from '@mui/material';
import React, { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLowercaseRest, onDownload } from 'src/common/utils/helpers';
import { ApiApplication, ApiCommission } from 'src/http';
import { Commission } from '../commissions';
import { Loader } from '../loader';
import { Page } from '../page';
import useStyles from './styles';

export const Checking: ComponentType = () => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const classes = useStyles();

  const [commissions, setCommissions] = useState<Commission[] | null>(null);
  const getCommissions = async () => {
    let params = {
      skip: 0,
      take: 999,
      order: '-id',
    };
    try {
      const data = await ApiCommission.fetchAll(params);
      setCommissions(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  useEffect(() => {
    getCommissions();
  }, []);

  const [taskId, setTaskId] = useState<number | string>('');
  const [mygov, setMyGov] = useState<any>(null);
  const [tibtoifa, setTibtoifa] = useState<any>(null);

  const onSubmit = async () => {
    setIsLoading(true);
    try {
      const _mygov: any = await ApiApplication.getMyGovApplicationCheck(Number(taskId));
      const _tibtoifa: any = await ApiApplication.getApplicationCheck(Number(taskId));
      setMyGov(_mygov.task);
      setTibtoifa(_tibtoifa.hits[0]);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  // SNACK
  const [snackOpen, setSnackOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleCloseSnack = () => {
    setSnackOpen(false);
  };
  const renew = async () => {
    setIsLoading(true);
    try {
      await ApiApplication.getMyGovApplicationChange(Number(taskId));
      setSnackOpen(true);
    } catch (error) {
      setError('error');
      setSnackOpen(true);
    }
    setIsLoading(false);
  };

  const view = () => {
    if (isLoading) return <Loader minHeight="50vh" />;
    return (
      <Box>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnack}
        >
          {error ? (
            <Alert onClose={handleCloseSnack} severity="error" sx={{ width: '100%' }}>
              <div> Ma'lumotlar yuklanmadi. Iltimos qaytadan urinib ko'ring! </div>
            </Alert>
          ) : (
            <Alert onClose={handleCloseSnack} severity="success" sx={{ width: '100%' }}>
              Ma'lumotlar yuklandi
            </Alert>
          )}
        </Snackbar>
        <Box display={'flex'} sx={{ mt: 2, mb: 4 }} gap={2}>
          <TextField
            placeholder="Task ID"
            size="small"
            type="number"
            value={taskId}
            onChange={(e) => {
              setTaskId(e.target.value);
            }}
          />
          <Button onClick={onSubmit} variant="contained">
            {t('search')}
          </Button>
        </Box>
        <Box display={'flex'} gap={3} mt={2}>
          <Box sx={{ minWidth: '45%', bgcolor: '#fff', p: 1, borderRadius: 1 }}>
            <Typography variant="h2" mb={2} mt={1}>
              Tibtoifa.ssv.uz
            </Typography>
            {tibtoifa && (
              <Box display={'flex'} justifyContent={'space-between'} alignItems={'flex-start'}>
                <List className={classes.list} sx={{ p: 0 }}>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('name.full', 'F.I.Sh')}
                    </Typography>
                    <Typography variant="subtitle2">
                      {capitalizeFirstLowercaseRest(tibtoifa?.user?.lastName) +
                        ' ' +
                        capitalizeFirstLowercaseRest(tibtoifa?.user?.firstName) +
                        ' ' +
                        capitalizeFirstLowercaseRest(tibtoifa?.user?.middleName)}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('Ariza raqami')}:
                    </Typography>
                    <Typography variant="subtitle2"> {tibtoifa?.uid}</Typography>
                  </ListItem>
                  {tibtoifa.appFrom === 'mygov.uz' ? (
                    <ListItem className={classes.listItem}>
                      <Typography variant="body2" mr={3} color="grey.600">
                        {t('My.gov.uz raqami')}:
                      </Typography>
                      <Typography variant="subtitle2"> {tibtoifa.taskId}</Typography>
                    </ListItem>
                  ) : null}
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('status', 'Status')}:
                    </Typography>
                    <Typography variant="subtitle2">
                      {' '}
                      {t('appealStatus.' + tibtoifa.status)}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="h3" my={1} color="grey.900">
                      {t("Shaxsiy ma'lumotlar", "Shaxsiy ma'lumotlar")}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.phone', 'Telefon')}:
                    </Typography>
                    <Typography variant="subtitle2">+998 {tibtoifa.indPhone}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.dob', "Tug'ilgan sanasi")}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.user?.dob}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.pin', 'PINFL')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.user?.pin}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.passportSerialNumber', 'passportSerialNumber')}:
                    </Typography>
                    <Typography variant="subtitle2">
                      {tibtoifa?.user?.passportSeries + ' ' + tibtoifa?.user?.passportNumber}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.passportIssueDate', 'passportIssueDate')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.user?.passportIssueDate}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.passportIssuePlace', 'passportIssuePlace')}:
                    </Typography>
                    <Typography variant="subtitle2">
                      {tibtoifa?.user?.passportIssuePlace}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.passportExpireDate', 'passportExpireDate')}:
                    </Typography>
                    <Typography variant="subtitle2">
                      {tibtoifa?.user?.passportExpireDate}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.gender', 'gender')}:
                    </Typography>
                    <Typography variant="subtitle2">
                      {t('gender.' + tibtoifa?.user?.gender)}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      OneID {t('profile.phone', 'phone')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.user?.phone}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('profile.email', 'email')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.user?.email}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="h3" my={1} color="grey.900">
                      I. {t('Малакасига оид маълумотлар', "Malakasiga oid ma'lumotlar")}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('workplace', 'workplace')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.workplace}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('position', 'position')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.position}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('workExperienceYear', 'workExperienceYear')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.workExperienceYear}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('specialtyWorkExperience', 'specialtyWorkExperience')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa?.specialtyWorkExperience}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('claimedQualification', 'claimedQualification')}:
                    </Typography>
                    <Typography variant="subtitle2">
                      {t(
                        ['Олий', 'Биринчи', 'Иккинчи', 'Учинчи'][
                          Number(tibtoifa.claimedQualification) - 1
                        ]
                      )}
                    </Typography>
                  </ListItem>
                   <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('electronicWorkBook', 'electronicWorkBook')}:
                    </Typography>
                    {tibtoifa.electronicWorkBook ? (
                      <Button
                        onClick={() => onDownload(tibtoifa.electronicWorkBook, tibtoifa.appFrom)}
                        variant="outlined"
                        color="primary"
                        sx={{ p: '5px 10px' }}
                      >
                        <Download /> &nbsp;
                        {t('action.download')}
                      </Button>
                    ) : null}
                  </ListItem>
                  <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('documentWork', 'Mehnat faoliyatini tasdiqlovchi hujjat')}:
                    </Typography>
                    {tibtoifa.documentWork ? (
                      <Button
                        onClick={() => onDownload(tibtoifa.documentWork, tibtoifa.appFrom)}
                        variant="outlined"
                        color="primary"
                        sx={{ p: '5px 10px' }}
                      >
                        <Download /> &nbsp;
                        {t('action.download')}
                      </Button>
                    ) : null}
                  </ListItem>
                  <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('presentation', 'Taqdimot hujjatlari')}:
                    </Typography>
                    {tibtoifa.presentation ? (
                      <Button
                        onClick={() => onDownload(tibtoifa.presentation, tibtoifa.appFrom)}
                        variant="outlined"
                        color="primary"
                        sx={{ p: '5px 10px' }}
                      >
                        <Download /> &nbsp;
                        {t('action.download')}
                      </Button>
                    ) : null}
                  </ListItem>
                  <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="h3" my={1} color="grey.900">
                      II. {t('Профессионал таълим ташкилотларида ўқиганлигини тасдиқловчи архив')}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('copyDiploma', 'Diplom nusxasi')}:
                    </Typography>
                    {tibtoifa.copyDiploma ? (
                      <Button
                        onClick={() => onDownload(tibtoifa.copyDiploma, tibtoifa.appFrom)}
                        variant="outlined"
                        color="primary"
                        sx={{ p: '5px 10px' }}
                      >
                        <Download /> &nbsp;
                        {t('action.download')}
                      </Button>
                    ) : null}
                  </ListItem>
                  <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('copyDocTraining', 'Kasbiy qayta tayyorlash hujjati')}:
                    </Typography>
                    {tibtoifa.copyDocTraining ? (
                      <Button
                        onClick={() => onDownload(tibtoifa.copyDocTraining, tibtoifa.appFrom)}
                        variant="outlined"
                        color="primary"
                        sx={{ p: '5px 10px' }}
                      >
                        <Download /> &nbsp;
                        {t('action.download')}
                      </Button>
                    ) : null}
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="h3" my={1} color="grey.900">
                      III. {t('Амалдаги малака тоифаси: (агар мавжуд бўлса)')}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('qualificationCategory', 'qualificationCategory')}:
                    </Typography>
                    {tibtoifa.appFrom === 'mygov.uz' ? (
                      <Typography variant="subtitle2">
                        {tibtoifa.qualificationCategory === ''
                          ? t('attestation.absent')
                          : t(
                              ['attestation.absent', 'Олий', 'Биринчи', 'Иккинчи', 'Учинчи'][
                                Number(tibtoifa.qualificationCategory) - 1
                              ]
                            )}
                      </Typography>
                    ) : (
                      <Typography variant="subtitle2">
                        {t(
                          ['attestation.absent', 'Олий', 'Биринчи', 'Иккинчи', 'Учинчи'][
                            Number(tibtoifa.qualificationCategory)
                          ]
                        )}
                      </Typography>
                    )}
                  </ListItem>
                  {tibtoifa.qualificationCategory !== '0' ? (
                    <>
                      <ListItem className={classes.listItem}>
                        <Typography variant="body2" mr={3} color="grey.600">
                          {t('qualificationCategoryIssued', 'Berilgan sanasi')}:
                        </Typography>
                        <Typography variant="subtitle2">
                          {tibtoifa?.qualificationCategoryIssued}
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.listItem}>
                        <Typography variant="body2" mr={3} color="grey.600">
                          {t('qualificationCategorySpecialty', 'Berilgan vaqti')}:
                        </Typography>
                        <Typography variant="subtitle2">
                          {tibtoifa?.qualificationCategorySpecialty}
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.listItem} alignItems="flex-start">
                        <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                          {t('copyQualificationCategory', 'Sertifikat nusxasi')}:
                        </Typography>
                        {tibtoifa.copyQualificationCategory ? (
                          <Button
                            onClick={() =>
                              onDownload(tibtoifa.copyQualificationCategory, tibtoifa.appFrom)
                            }
                            variant="outlined"
                            color="primary"
                            sx={{ p: '5px 10px' }}
                          >
                            <Download /> &nbsp;
                            {t('action.download')}
                          </Button>
                        ) : null}
                      </ListItem>
                    </>
                  ) : null}
                  <ListItem className={classes.listItem}>
                    <Typography variant="h3" my={1} color="grey.900">
                      III. {t('Кейинги 5 йил давомида малака оширганлиги')}
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('creditAccumulated', 'Kreditlar hajmi')}:
                    </Typography>
                    <Typography variant="subtitle2">{tibtoifa.creditAccumulated}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('copyCertificateQualification', 'Sertigikat nusxasi')}:
                    </Typography>
                    {tibtoifa.copyCertificateQualification ? (
                      <Button
                        onClick={() =>
                          onDownload(tibtoifa.copyCertificateQualification, tibtoifa.appFrom)
                        }
                        variant="outlined"
                        color="primary"
                        sx={{ p: '5px 10px' }}
                      >
                        <Download /> &nbsp;
                        {t('action.download')}
                      </Button>
                    ) : null}
                  </ListItem>
                  <ListItem className={classes.listItem} alignItems="flex-start">
                    <Typography variant="body2" mr={3} color="grey.600" maxWidth={'50%'}>
                      {t('invoice', 'To\'lov kvitansiyasi')}:
                    </Typography>
                    {tibtoifa.invoice ? (
                      <Button
                        onClick={() => onDownload(tibtoifa.invoice, tibtoifa.appFrom)}
                        variant="outlined"
                        color="primary"
                        sx={{ p: '5px 10px' }}
                      >
                        <Download /> &nbsp;
                        {t('action.download')}
                      </Button>
                    ) : null}
                  </ListItem>
                </List>
              </Box>
            )}
          </Box>
          <Box sx={{ minWidth: '45%', bgcolor: '#fff', p: 1, borderRadius: 1, pt: 2 }}>
            <img src="/assets/my.gov.uz.svg" alt="" width={150} />
            {mygov && (
              <Box display={'flex'} justifyContent={'space-between'} alignItems={'flex-start'}>
                <List className={classes.list} sx={{ p: 0, width: '100%' }}>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('ID')}:
                    </Typography>
                    <Typography variant="subtitle2">{mygov.id}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('Yaratilgan sana')}:
                    </Typography>
                    <Typography variant="subtitle2">{mygov.created_date}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t("O'zgartirilgan sana")}:
                    </Typography>
                    <Typography variant="subtitle2">{mygov.last_update}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('current_node')}:
                    </Typography>
                    <Typography variant="subtitle2">{mygov.current_node}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('operator_org')}:
                    </Typography>
                    <Typography variant="subtitle2">{mygov.operator_org}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('operator_org_id')}:
                    </Typography>
                    <Typography variant="subtitle2">{mygov.operator_org_id}</Typography>
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    <Typography variant="body2" mr={3} color="grey.600">
                      {t('Status')}:
                    </Typography>
                    {mygov.status === 'new' ? (
                      <Box display={'flex'} gap={3} alignItems={'flex-start'}>
                        <Typography variant="subtitle2">{mygov.status}</Typography>
                        <Button onClick={renew} variant="contained">
                          Yangilash
                        </Button>
                      </Box>
                    ) : (
                      <Typography variant="subtitle2">{mygov.status}</Typography>
                    )}
                  </ListItem>
                </List>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    );
  };

  return <Page title={t('checking', 'Tekshiruv')}>{view()}</Page>;
};
